export const insertBase = "insertProcess";

export const TRIGGER_INSERT_PROCESS = `${insertBase}/triggerInsert`;
export const TRIGGER_EXPORT_PROCESS = `${insertBase}/triggerExport`;
